import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import { unref as _unref, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createBlock as _createBlock, isRef as _isRef, createVNode as _createVNode, renderList as _renderList, vShow as _vShow, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = {
  key: 1,
  "class": "PBDropdown__top"
};
var _hoisted_2 = {
  key: 2,
  "class": "PBDropdown__title"
};
var _hoisted_3 = {
  ref: "dropdown"
};
var _hoisted_4 = ["onClick"];
var _hoisted_5 = {
  key: 0,
  "class": "PBDropdown__empty"
};
var _hoisted_6 = {
  key: 3,
  "class": "PBDropdown__top"
};
import { onMounted } from 'vue';

import { useSlots, ref, computed, nextTick, watch } from 'vue';
import { onClickOutside } from '@vueuse/core';
export default {
  __name: 'PBDropdown',
  props: {
    iconOnly: Boolean,
    title: {
      type: String,
      "default": ""
    },
    search: Boolean,
    disabled: Boolean,
    noPadding: Boolean,
    isShown: Boolean,
    scrollable: Boolean,
    placeholder: {
      type: String,
      "default": ""
    },
    top: Boolean,
    left: Boolean,
    bordered: Boolean,
    modelValue: {
      type: Object,
      "default": null
    },
    selectable: {
      type: Boolean,
      "default": true
    },
    options: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    valueKey: {
      type: String,
      "default": "value"
    },
    textKey: {
      type: String,
      "default": "text"
    },
    chevron: {
      type: Boolean,
      "default": true
    },
    width: {
      type: String,
      "default": "fit-content"
    },
    height: {
      type: Number,
      "default": 300
    },
    scroll: {
      type: Boolean,
      "default": true
    },
    triggerIconStyles: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    auto: Boolean
  },
  emits: ["hide-dropdown", "open-dropdown", "input", "update:modelValue"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var slots = useSlots();
    var selectedOption = ref(null);
    var query = ref("");
    var dropdownRef = ref(null);
    var isDropdown = ref(false);
    var searchInputRef = ref(null);
    var filteredOptions = computed(function () {
      return props.options.filter(function (option) {
        return option[props.textKey].toLowerCase().includes(query.value.toLowerCase());
      });
    });
    function hideDropdown() {
      isDropdown.value = false;
      emit("hide-dropdown");
    }
    function setSelectedOption(option) {
      selectedOption.value = option;
      emit("update:modelValue", selectedOption.value);
      hideDropdown();
    }
    function isActive(option) {
      return selectedOption.value && selectedOption.value[props.valueKey] === option[props.valueKey];
    }
    function toggleDropdown() {
      return _toggleDropdown.apply(this, arguments);
    }
    function _toggleDropdown() {
      _toggleDropdown = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              isDropdown.value = !isDropdown.value;
              if (!isDropdown.value) {
                _context2.next = 5;
                break;
              }
              _context2.next = 4;
              return nextTick();
            case 4:
              emit("open-dropdown");
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _toggleDropdown.apply(this, arguments);
    }
    onClickOutside(dropdownRef, hideDropdown);
    onMounted(function () {
      setSelectedOption(props.modelValue);
    });
    watch(function () {
      return props.isShown;
    }, function (value) {
      return isDropdown.value = value;
    });
    watch(function () {
      return props.modelValue;
    }, function (value) {
      return selectedOption.value = value;
    });
    watch(isDropdown, /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(value) {
        var _searchInputRef$value, input;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(value && props.search && props.options.length > 6)) {
                _context.next = 5;
                break;
              }
              _context.next = 3;
              return nextTick();
            case 3:
              input = (_searchInputRef$value = searchInputRef.value) === null || _searchInputRef$value === void 0 ? void 0 : _searchInputRef$value.querySelector("input");
              input === null || input === void 0 ? void 0 : input.focus();
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    return function (_ctx, _cache) {
      var _component_PBIcon = _resolveComponent("PBIcon");
      var _component_PBInput = _resolveComponent("PBInput");
      return _openBlock(), _createElementBlock("div", {
        ref_key: "dropdownRef",
        ref: dropdownRef,
        "class": "PBDropdown"
      }, [_createElementVNode("div", {
        "class": _normalizeClass(["PBDropdown__trigger", {
          bordered: __props.bordered,
          opened: _unref(isDropdown),
          disabled: __props.disabled
        }]),
        onClick: toggleDropdown
      }, [_createElementVNode("div", {
        "class": _normalizeClass(["PBDropdown__placeholder", {
          'PBDropdown__placeholder--icon': !__props.selectable && !__props.placeholder || __props.iconOnly
        }])
      }, [_unref(slots).icon ? _renderSlot(_ctx.$slots, "icon", {
        key: 0
      }) : _createCommentVNode("", true), !__props.selectable && __props.placeholder ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createTextVNode(_toDisplayString(__props.placeholder), 1)], 64)) : !__props.iconOnly ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 2
      }, [_createTextVNode(_toDisplayString(_unref(selectedOption) ? _unref(selectedOption)[__props.textKey] : __props.placeholder), 1)], 64)) : _createCommentVNode("", true)], 2), __props.chevron ? (_openBlock(), _createBlock(_component_PBIcon, {
        key: 0,
        "class": "PBDropdown__trigger-icon",
        style: _normalizeStyle(_objectSpread({}, __props.triggerIconStyles)),
        name: "chevron",
        w: 12,
        h: 7
      }, null, 8, ["style"])) : _createCommentVNode("", true)], 2), _withDirectives(_createElementVNode("div", {
        "class": _normalizeClass({
          'PBDropdown__dropdown scroller border border-solid border-zinc-700 rounded-md shadow-lg': true,
          left: __props.left,
          top: __props.top,
          'no-padding': __props.noPadding,
          scrollable: __props.scrollable,
          auto: __props.auto
        }),
        style: _normalizeStyle({
          minWidth: __props.width
        })
      }, [__props.search && __props.options.length > 6 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "searchInputRef",
        ref: searchInputRef,
        "class": _normalizeClass({
          PBDropdown__search: true,
          'no-title': !__props.title
        })
      }, [_createVNode(_component_PBInput, {
        modelValue: _unref(query),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(query) ? query.value = $event : null;
        }),
        icon: "search",
        placeholder: "Search",
        "no-border": ""
      }, null, 8, ["modelValue"])], 2)) : _createCommentVNode("", true), _unref(slots).top ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_renderSlot(_ctx.$slots, "top")])) : _createCommentVNode("", true), __props.title ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.title), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [!_unref(slots).menu ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        style: _normalizeStyle("max-height: ".concat(__props.height, "px;"))
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredOptions), function (option, index) {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          "class": "PBDropdown__item",
          onClick: function onClick($event) {
            return setSelectedOption(option);
          }
        }, [_createElementVNode("div", {
          "class": _normalizeClass({
            active: __props.selectable && isActive(option),
            padding: !_unref(slots).menu
          })
        }, [_unref(slots).option ? _renderSlot(_ctx.$slots, "option", {
          key: 0,
          option: option
        }) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createTextVNode(_toDisplayString(option[__props.textKey]), 1)], 64)), __props.selectable ? (_openBlock(), _createBlock(_component_PBIcon, {
          key: 2,
          "class": "PBDropdown__check",
          name: "check",
          w: 16,
          h: 12
        })) : _createCommentVNode("", true)], 2)], 8, _hoisted_4);
      }), 128)), _unref(filteredOptions).length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, " No data found ")) : _createCommentVNode("", true)], 4)) : _renderSlot(_ctx.$slots, "menu", {
        key: 1,
        close: hideDropdown
      })], 512), _unref(slots).bottom ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_renderSlot(_ctx.$slots, "bottom")])) : _createCommentVNode("", true)], 6), [[_vShow, _unref(isDropdown)]])], 512);
    };
  }
};